<style>
  .form-control {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    border: 1px solid rgba(0,0,0,0.2);
    padding: 0.25rem;
    padding-left: 1rem;
    background-color: rgba(0,0,0,0.05);
    border-radius: 4px;
  }
  .form-control label {
    flex-shrink: 0;
    margin-right: 0.5rem;
  }
	.form-control input {
		width: 100%;
    margin-bottom: 0;
    text-align: right;
    border: none;
    background-color: transparent;
  }

  .form-control--checkbox {
    padding-right: 1rem;
  }

  .form-control--checkbox label {
    width: 100%;
    margin-right: 0;
    display: flex;
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
  }

  .form-control--checkbox input {
    width: auto;
    margin-left: auto;
    margin-right: 0.5rem;
  }
  
  .form-control input:focus {
    outline: none;
  }
</style>

<script>
  import { rounds, timeOn, timeOff, playSounds } from '../configStore';
  
  const handleFocus = (e) => {
    e.target.select();
  }
</script>

<div>
  <div class="form-control">
    <label for="rounds">Rounds</label>
    <input id="rounds" bind:value={$rounds} type="number" min="2" on:focus={handleFocus} />
  </div>
  <div class="form-control">
    <label for="timeOn">Time on</label>
    <input id="timeOn" bind:value={$timeOn} type="number" min="2" on:focus={handleFocus} />
  </div>
  <div class="form-control">
    <label for="timeOff">Rest</label>
    <input id="timeOff" bind:value={$timeOff} type="number" min="2" on:focus={handleFocus} />
  </div>
  <div class="form-control form-control--checkbox">
    <label for="playSounds"><span>Sounds</span>
      <input id="playSounds" bind:checked={$playSounds} type="checkbox" on:focus={handleFocus} />
    </label>
  </div>
</div>
